import AssetCard from './AssetCard'

export default AssetCard
